import Analytics from 'analytics';
import doNotTrack from 'analytics-plugin-do-not-track';

const DEBUG_ENABLED = process.env.REACT_APP_ANALYTICS_DEBUG_ENABLED === 'true';

// Documentation: https://getanalytics.io
const __analytics = Analytics({
  app: 'CollectWeb',
  debug: DEBUG_ENABLED,
  plugins: [doNotTrack()],
});

const track = (event: string, data?: unknown) => {
  // This is a no-op, because of the Snowplow deprecation. Consider using Pico if needed.
};

const trackProps = (props: Record<string, unknown>) => {
  // This is a no-op, because of the Snowplow deprecation. Consider using Pico if needed.
};

const trackPageView = () => {
  // This is a no-op, because of the Snowplow deprecation. Consider using Pico if needed.
};

export { __analytics, track, trackProps, trackPageView };
